import CommentAPI from '@/app/apis/main/comment/comment-api.js';

export default {
	/**
	 * @param {*} commentDetails
	 * @returns {Promise}
	 */
	async saveComment(commentDetails) {
		return CommentAPI.saveComment(commentDetails);
	},

	async getCommentById(commentId) {
		return CommentAPI.getCommentById(commentId);
	},

	async getComments(options) {
		return CommentAPI.getComments(options);
	},

	async updateComment(commentDetails){
		return CommentAPI.updateComment(commentDetails);
	},
	
	async deleteComment(commentId) {
		return CommentAPI.deleteComment(commentId);
	}
}